/** 团队版购买弹窗层级（叠在全屏会员弹窗 1009 之上） */
export const TEAM_EDITION_MODAL_Z_INDEX = 1010;

/**
 * 团队版购买弹窗内的二次确认框层级
 * NOTE: Modal.confirm 默认 zIndex 为 1000，会被购买弹窗盖住导致无法点击确认，必须高于购买弹窗
 */
export const TEAM_EDITION_CONFIRM_Z_INDEX = TEAM_EDITION_MODAL_Z_INDEX + 10;
